import { render } from "./GeneratePostcode.vue?vue&type=template&id=62b81875"
import script from "./GeneratePostcode.vue?vue&type=script&lang=js"
export * from "./GeneratePostcode.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__